module.exports = "/_next/static/images/arrow-253a19fb95dbfc316f1683355823ee5b.svg";